import React from 'react'

const Googleplay = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M3.25 22.2083V3.7916C3.25 3.15243 3.61833 2.5891 4.16 2.3291L14.8308 12.9999L4.16 23.6708C3.61833 23.3999 3.25 22.8474 3.25 22.2083ZM18.2108 16.3799L6.55417 23.1183L15.7517 13.9208L18.2108 16.3799ZM21.84 11.7108C22.2083 12.0033 22.4792 12.4583 22.4792 12.9999C22.4792 13.5416 22.2408 13.9749 21.8617 14.2783L19.3808 15.7083L16.6725 12.9999L19.3808 10.2916L21.84 11.7108ZM6.55417 2.8816L18.2108 9.61994L15.7517 12.0791L6.55417 2.8816Z" fill="currentColor"></path>
</svg>
    )
}

export default Googleplay
